import * as signalR from '@microsoft/signalr';
import { ApiResources } from '@services/utils';

const connection = new signalR.HubConnectionBuilder()
  .withUrl(`${process.env.REACT_APP_CDX_URL}/${ApiResources.messageHub}`)
  .withAutomaticReconnect()
  .build();

export default connection;
